import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  heading: theme => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    margin-bottom: ${theme.spacing.md};
  `,

  boxHeader: css`
    display: flex;
    justify-content: end;
    margin-bottom: 4px;
    svg {
      cursor: pointer;
    }
  `,

  fullName: css`
    word-wrap: break-word;
  `,

  containerWrapper: theme => css`
    display: flex;
    @media (max-width: ${theme.grid.breakpoint.md}) {
      flex-direction: column;
      gap: 20px;
    }
    hr {
      flex-grow: 1;
      border: none;
      border-bottom: 1px solid ${theme.colors.neutral[100]};
    }
  `,

  sideContent: theme => css`
    display: flex;
    flex-direction: column;
    width: 50%;
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      width: 100%;
    }
    gap: ${theme.spacing.xs};
    span {
      display: flex;
      margin-bottom: ${theme.spacing.xxs};
      color: ${theme.colors.neutral[300]};
    }
    p {
      color: ${theme.colors.neutral[400]};
    }
  `,

  footer: theme => css`
    display: flex;
    justify-content: end;
    margin-top: ${theme.spacing.xs};
  `,

  alertWrapper: theme => css`
    margin-bottom: ${theme.spacing.md};
  `,

  editIcon: css`
    cursor: pointer;
  `,

  pregnancyTitle: theme => css`
    margin-top: ${theme.spacing.md};
  `,
})

export default useStyles
